import React, { Component } from 'react'

class NavLogoAlt extends Component {
  render() {
    return (
      <svg width="256.88" height="32" viewBox="0 0 432.6 53.89" alt="logo">
        <style>
          {`.cls-1{fill:#000000}`}
          {`.cls-2{fill:#00a94f}`}
        </style>
        <polygon
          className="cls-1"
          points="114.07 31.31 114.07 16.41 122.77 5.09 122.77 31.31 114.07 31.31"
        />
        <polygon
          className="cls-2"
          points="114.07 2.89 114.07 14.04 122.77 2.89 114.07 2.89"
        />
        <polygon
          className="cls-2"
          points="11.45 42.25 11.45 24.5 17.49 16.86 17.49 37.02 34.28 37.02 34.28 7.79 40.39 0 40.39 42.25 11.45 42.25"
        />
        <polygon
          className="cls-2"
          points="0 49.97 0 7.77 28.9 7.77 28.9 25.55 22.86 32.94 22.86 13.01 6.1 13.01 6.1 42.25 0 49.97"
        />
        <path
          className="cls-1"
          d="m65.91,2.89h8.54v16.96c0,1.67-.25,3.27-.77,4.76-.51,1.49-1.31,2.8-2.4,3.92-1.09,1.12-2.24,1.91-3.43,2.36-1.66.63-3.66.95-5.99.95-1.35,0-2.82-.09-4.42-.28-1.59-.2-2.92-.58-3.99-1.16-1.07-.57-2.05-1.39-2.94-2.45-.89-1.06-1.5-2.16-1.82-3.28-.53-1.81-.79-3.41-.79-4.81V2.89h8.54v17.36c0,1.55.42,2.77,1.26,3.64.84.87,2,1.31,3.49,1.31s2.63-.43,3.47-1.29c.84-.86,1.26-2.08,1.26-3.66V2.89Z"
        />
        <polygon
          className="cls-1"
          points="80.18 2.89 88.18 2.89 98.61 18.63 98.61 2.89 106.68 2.89 106.68 31.35 98.61 31.35 88.23 15.73 88.23 31.35 80.18 31.35 80.18 2.89"
        />
        <path
          className="cls-1"
          d="m145.9,19.7l7.5,2.33c-.5,2.16-1.29,3.96-2.38,5.41-1.09,1.45-2.43,2.55-4.03,3.28-1.61.74-3.65,1.11-6.13,1.11-3.02,0-5.48-.45-7.38-1.35-1.91-.9-3.56-2.48-4.95-4.74-1.38-2.26-2.08-5.16-2.08-8.69,0-4.71,1.22-8.33,3.66-10.86,2.44-2.53,5.89-3.79,10.34-3.79,3.49,0,6.24.73,8.23,2.18,2,1.44,3.48,3.67,4.46,6.67l-7.56,1.73c-.26-.86-.54-1.5-.83-1.9-.47-.68-1.06-1.2-1.75-1.56-.69-.36-1.47-.55-2.33-.55-1.94,0-3.42.81-4.46,2.41-.78,1.19-1.17,3.06-1.17,5.6,0,3.15.46,5.32,1.4,6.49.92,1.17,2.24,1.76,3.93,1.76s2.88-.47,3.72-1.42c.84-.95,1.45-2.32,1.83-4.12"
        />
        <path
          className="cls-1"
          d="m156.48,17.14c0-4.64,1.25-8.26,3.77-10.85,2.52-2.59,6.03-3.88,10.54-3.88s8.16,1.27,10.65,3.81c2.5,2.54,3.75,6.11,3.75,10.69,0,3.32-.56,6.05-1.65,8.18-1.09,2.14-2.66,3.79-4.72,4.98-2.06,1.19-4.63,1.78-7.7,1.78s-5.72-.51-7.76-1.53c-2.04-1.02-3.71-2.64-4.98-4.85-1.27-2.22-1.9-4.99-1.9-8.32m8.56.04c0,2.87.52,4.94,1.55,6.2,1.04,1.25,2.46,1.88,4.25,1.88s3.26-.61,4.27-1.85c1.01-1.23,1.51-3.43,1.51-6.62,0-2.68-.52-4.64-1.58-5.87-1.04-1.23-2.48-1.86-4.28-1.86s-3.11.63-4.16,1.88c-1.05,1.26-1.56,3.33-1.56,6.23"
        />
        <polygon
          className="cls-1"
          points="189.72 2.89 200.98 2.89 205.32 20.21 209.62 2.89 220.88 2.89 220.88 31.35 213.87 31.35 213.87 9.64 208.47 31.35 202.12 31.35 196.72 9.64 196.72 31.35 189.72 31.35 189.72 2.89"
        />
        <path
          className="cls-1"
          d="m228.98,3.77c.62.59.94,1.31.94,2.16s-.31,1.57-.94,2.16c-.62.59-1.39.88-2.3.88s-1.67-.29-2.29-.88c-.63-.59-.94-1.31-.94-2.16s.31-1.58.94-2.16c.62-.59,1.39-.88,2.29-.88s1.67.29,2.3.88Zm-.46.37c-.5-.49-1.11-.73-1.84-.73s-1.34.25-1.83.73c-.5.49-.75,1.09-.75,1.8s.25,1.3.75,1.8c.5.49,1.11.73,1.83.73s1.34-.24,1.84-.73c.5-.49.75-1.09.75-1.8s-.25-1.31-.75-1.8Zm-3.24.04h1.47c.4,0,.71.08.93.25.22.17.34.4.34.7,0,.33-.12.58-.34.76-.17.14-.38.22-.65.26l1.05,1.54h-.67l-.95-1.52h-.61v1.52h-.58v-3.52Zm.58,1.53h.78c.27,0,.47-.05.59-.14.12-.09.19-.24.19-.44,0-.17-.06-.3-.19-.39-.12-.08-.32-.12-.59-.12h-.78v1.08Z"
        />
        <path
          className="cls-1"
          d="m52.34,41.77h1.82l4.24,11.8h-1.71l-1.2-3.42h-4.71l-1.24,3.42h-1.65l4.45-11.8Zm-1.06,6.97h3.71l-1.82-5.23h0l-1.9,5.23Z"
        />
        <path
          className="cls-1"
          d="m64.51,41.77h4.85c1.5,0,2.69.53,3.58,1.6.89,1.07,1.33,2.5,1.33,4.31s-.45,3.23-1.36,4.3c-.91,1.07-2.13,1.6-3.67,1.6h-4.72v-11.8Zm1.6,10.43h2.92c1.14,0,2.03-.39,2.65-1.18.62-.79.94-1.9.94-3.35s-.3-2.57-.9-3.36c-.6-.79-1.45-1.19-2.55-1.19h-3.06v9.07Z"
        />
        <path
          className="cls-1"
          d="m76.15,41.77h1.48v1.64h-1.48v-1.64Zm.01,3.21h1.44v8.59h-1.44v-8.59Z"
        />
        <path
          className="cls-1"
          d="m78.83,44.98h1.69l2.3,7.03h0l2.38-7.03h1.59l-3.2,8.59h-1.55l-3.21-8.59Z"
        />
        <path
          className="cls-1"
          d="m88.02,41.77h1.48v1.64h-1.48v-1.64Zm.02,3.21h1.44v8.59h-1.44v-8.59Z"
        />
        <path
          className="cls-1"
          d="m96.56,47.47c-.04-.48-.24-.85-.58-1.11-.35-.26-.81-.39-1.39-.39s-1.05.11-1.37.32c-.31.21-.47.51-.47.91,0,.31.11.54.33.69.22.16.65.31,1.31.47l1.49.36c.83.2,1.43.48,1.79.84.35.36.53.85.53,1.49,0,.85-.31,1.53-.92,2.03-.61.5-1.44.75-2.49.75-1.21,0-2.11-.24-2.7-.72-.59-.48-.92-1.23-.99-2.26h1.39c.07.61.28,1.05.65,1.33.36.27.91.41,1.66.41.65,0,1.14-.13,1.47-.37.34-.25.5-.6.5-1.08,0-.3-.11-.53-.33-.68-.22-.16-.66-.31-1.32-.47l-1.49-.35c-.81-.19-1.38-.46-1.73-.81-.34-.35-.51-.83-.51-1.45,0-.81.29-1.45.86-1.92.58-.47,1.35-.71,2.34-.71s1.8.24,2.39.73c.59.49.91,1.16.94,2.02h-1.36Z"
        />
        <path
          className="cls-1"
          d="m99.89,41.77h1.48v1.64h-1.48v-1.64Zm.02,3.21h1.44v8.59h-1.44v-8.59Z"
        />
        <path
          className="cls-1"
          d="m104.13,52.55c-.74-.84-1.1-1.93-1.1-3.28s.37-2.45,1.1-3.29c.74-.83,1.7-1.25,2.89-1.25s2.16.42,2.9,1.25c.73.84,1.1,1.93,1.1,3.29s-.37,2.45-1.1,3.28c-.73.83-1.7,1.25-2.9,1.25s-2.15-.42-2.89-1.25Zm4.7-.88c.45-.59.68-1.39.68-2.4s-.23-1.8-.68-2.4c-.45-.6-1.05-.9-1.81-.9s-1.36.3-1.81.9c-.45.6-.67,1.4-.67,2.4s.22,1.81.67,2.4c.45.6,1.05.89,1.81.89s1.36-.3,1.81-.89Z"
        />
        <path
          className="cls-1"
          d="m112.66,44.98h1.37v1.27l.32-.43c.63-.74,1.41-1.1,2.35-1.1s1.68.26,2.19.77c.51.51.77,1.24.77,2.19v5.89h-1.44v-5.4c0-.75-.15-1.3-.44-1.63-.29-.33-.76-.5-1.42-.5-.69,0-1.25.26-1.65.79-.41.52-.61,1.24-.61,2.14v4.6h-1.44v-8.59Z"
        />
        <path
          className="cls-1"
          d="m126.98,52.55c-.73-.84-1.1-1.93-1.1-3.28s.37-2.45,1.1-3.29c.73-.83,1.7-1.25,2.89-1.25s2.16.42,2.9,1.25c.73.84,1.1,1.93,1.1,3.29s-.37,2.45-1.1,3.28c-.73.83-1.7,1.25-2.9,1.25s-2.15-.42-2.89-1.25Zm4.7-.88c.45-.59.67-1.39.67-2.4s-.23-1.8-.67-2.4c-.45-.6-1.05-.9-1.81-.9s-1.36.3-1.81.9c-.45.6-.67,1.4-.67,2.4s.22,1.81.67,2.4c.45.6,1.05.89,1.81.89s1.36-.3,1.81-.89Z"
        />
        <path
          className="cls-1"
          d="m137.31,46.17v7.4h-1.44v-7.4h-1.19v-1.19h1.19v-1.46c0-.64.19-1.12.56-1.44.37-.32.94-.48,1.69-.48l.63.02v1.3l-.57-.02c-.28,0-.49.09-.64.27-.15.18-.22.43-.22.77v1.04h1.44v1.19h-1.44Z"
        />
        <path
          className="cls-1"
          d="m154.16,49.24c0,1.46-.41,2.6-1.23,3.42-.82.82-1.95,1.23-3.41,1.23s-2.67-.39-3.46-1.18c-.79-.79-1.19-1.95-1.19-3.47v-7.47h1.6v7.35c0,1.1.26,1.93.78,2.5.52.57,1.28.85,2.27.85s1.75-.29,2.27-.85c.52-.57.77-1.4.77-2.5v-7.35h1.6v7.47Z"
        />
        <path
          className="cls-1"
          d="m158.24,53.57h-1.54v-11.8h1.92l5.91,9.59v-9.59h1.54v11.8h-1.75l-6.08-9.63v9.63Z"
        />
        <path className="cls-1" d="m168.81,41.77h1.6v11.8h-1.6v-11.8Z" />
        <path
          className="cls-1"
          d="m183.09,49.22c-.2,1.46-.76,2.6-1.67,3.42-.91.83-2.07,1.24-3.46,1.24-1.63,0-2.92-.56-3.89-1.68-.97-1.12-1.45-2.63-1.45-4.53s.5-3.41,1.51-4.54c1-1.13,2.35-1.69,4.04-1.69,1.33,0,2.43.35,3.28,1.03.86.68,1.37,1.63,1.54,2.83h-1.54c-.15-.78-.51-1.38-1.09-1.81-.57-.43-1.31-.64-2.22-.64-1.18,0-2.12.43-2.83,1.3-.7.87-1.05,2.04-1.05,3.51,0,1.56.33,2.75.97,3.57.65.82,1.59,1.23,2.83,1.23.91,0,1.67-.28,2.28-.85.6-.57,1.01-1.37,1.2-2.41h1.54Z"
        />
        <path
          className="cls-1"
          d="m185.99,52.18c-1.06-1.14-1.59-2.65-1.59-4.5s.53-3.36,1.59-4.51c1.06-1.15,2.44-1.72,4.16-1.72s3.11.57,4.17,1.72c1.06,1.15,1.59,2.65,1.59,4.51s-.53,3.36-1.59,4.5c-1.06,1.14-2.45,1.71-4.17,1.71s-3.1-.57-4.16-1.71Zm7.13-1.03c.76-.88,1.14-2.04,1.14-3.47s-.38-2.6-1.14-3.49c-.75-.89-1.75-1.33-2.98-1.33s-2.22.44-2.97,1.33c-.75.88-1.13,2.05-1.13,3.49s.38,2.59,1.13,3.47c.75.89,1.75,1.33,2.97,1.33s2.22-.44,2.98-1.33Z"
        />
        <path
          className="cls-1"
          d="m199.3,53.57h-1.55v-11.8h2.3l3.37,10.04h0l3.35-10.04h2.3v11.8h-1.55v-9.99h0l-3.33,9.99h-1.54l-3.34-9.95h0v9.95Z"
        />
        <path
          className="cls-1"
          d="m221.08,53.89c-1.64,0-2.96-.57-3.97-1.71-1.01-1.14-1.52-2.65-1.52-4.5s.51-3.36,1.55-4.51c1.03-1.15,2.38-1.72,4.05-1.72,1.29,0,2.4.37,3.33,1.09.93.72,1.47,1.65,1.63,2.78h-1.54c-.15-.78-.53-1.38-1.14-1.81-.61-.43-1.4-.64-2.38-.64-1.15,0-2.08.44-2.79,1.34-.71.89-1.07,2.06-1.07,3.51,0,1.53.35,2.72,1.03,3.56.69.84,1.66,1.26,2.91,1.26s2.2-.45,2.95-1.33c.12-.14.22-.29.32-.44.13-.21.24-.5.33-.87.09-.37.13-.73.13-1.06v-.15h-3.7v-1.35h5.17v6.24h-.99l-.39-1.49-.09.1c-.97,1.14-2.24,1.71-3.82,1.71Z"
        />
        <path className="cls-1" d="m228.69,41.77h1.45v11.8h-1.45v-11.8Z" />
        <path
          className="cls-1"
          d="m232.93,52.55c-.74-.84-1.1-1.93-1.1-3.28s.37-2.45,1.1-3.29c.74-.83,1.7-1.25,2.89-1.25s2.17.42,2.9,1.25c.73.84,1.1,1.93,1.1,3.29s-.36,2.45-1.1,3.28c-.73.83-1.7,1.25-2.9,1.25s-2.15-.42-2.89-1.25Zm4.7-.88c.45-.59.67-1.39.67-2.4s-.22-1.8-.67-2.4c-.45-.6-1.06-.9-1.81-.9s-1.36.3-1.81.9c-.45.6-.67,1.4-.67,2.4s.23,1.81.67,2.4c.45.6,1.05.89,1.81.89s1.36-.3,1.81-.89Z"
        />
        <path
          className="cls-1"
          d="m241.34,41.77h1.45v4.33c.63-.93,1.45-1.38,2.45-1.37,1.13,0,2.01.39,2.67,1.16.66.77.98,1.82.98,3.13,0,1.49-.33,2.66-.99,3.51-.66.85-1.58,1.27-2.75,1.27-.97,0-1.74-.37-2.31-1.11l-.14-.18v1.06h-1.36v-11.8Zm3.73,10.78c.76,0,1.33-.29,1.72-.85.39-.57.59-1.4.59-2.49s-.19-1.87-.56-2.39c-.37-.52-.95-.77-1.74-.77s-1.38.29-1.74.88c-.37.58-.55,1.51-.55,2.77,0,.91.2,1.62.59,2.12.4.5.96.75,1.69.75Z"
        />
        <path
          className="cls-1"
          d="m252.86,53.8c-.84,0-1.51-.22-2-.67-.49-.45-.74-1.06-.74-1.82s.23-1.38.69-1.84c.46-.46,1.14-.74,2.03-.85l1.96-.25c.16-.02.31-.04.46-.08.19-.05.33-.14.44-.29.1-.15.15-.33.15-.55v-.07c0-.46-.17-.82-.52-1.08-.35-.25-.83-.39-1.45-.39s-1.06.14-1.39.41c-.33.27-.54.69-.61,1.23h-1.33c.07-.94.4-1.65,1-2.12.59-.47,1.45-.71,2.55-.71,1.04,0,1.84.23,2.38.68.55.45.82,1.11.82,1.98v4.72c0,.14.04.26.13.35.09.09.2.13.35.13.04,0,.1,0,.19-.02.08,0,.17-.02.27-.05v1.04c-.14.05-.29.1-.44.13-.16.03-.29.05-.39.05-.55,0-.95-.15-1.19-.45-.16-.2-.28-.48-.34-.85-.11.14-.23.26-.37.39-.72.64-1.6.97-2.64.97Zm2.99-3.63v-.93c-.27.13-.56.22-.89.27l-1.33.19c-.69.1-1.2.26-1.52.49-.32.22-.48.54-.48.92,0,.48.13.85.39,1.11.26.26.64.39,1.12.39.76,0,1.4-.2,1.92-.62.36-.29.6-.62.72-.98.02-.07.04-.18.05-.33.02-.16.02-.33.02-.51Z"
        />
        <path className="cls-1" d="m259.77,41.77h1.45v11.8h-1.45v-11.8Z" />
        <path
          className="cls-2"
          d="m246.65,12v2.26h-11.01v5.86h9.93v2.26h-9.93v6.7h11.01v2.29h-13.28V12h13.28Z"
        />
        <path
          className="cls-2"
          d="m261.27,31.36h-2.25v-8.73c0-2.2-1.18-3.82-3.37-3.82s-3.62,1.62-3.62,3.77v8.79h-2.28v-14.37h2.2v1.56c.94-1.2,2.36-1.93,4.02-1.93,3.37,0,5.3,2.51,5.3,6.08v8.65Z"
        />
        <path
          className="cls-2"
          d="m277.98,30.69c0,4.6-2.86,7.73-7.09,7.73-3.27,0-5.81-1.81-6.51-4.74h2.38c.91,2.15,3.11,2.45,4.12,2.45,3.53,0,4.82-2.85,4.82-5.44v-1.51c-.99,1.4-2.7,2.54-4.69,2.54-3.96,0-6.91-3.38-6.91-7.53s2.95-7.56,6.91-7.56c2.03,0,3.8,1.2,4.77,2.65v-2.29h2.2v13.7Zm-6.96-11.86c-2.6,0-4.63,2.4-4.63,5.38s2.03,5.33,4.63,5.33,4.69-2.4,4.69-5.33-2.14-5.38-4.69-5.38Z"
        />
        <path
          className="cls-2"
          d="m283.72,14.82h-2.28v-2.82h2.28v2.82Zm0,16.54h-2.28v-14.37h2.28v14.37Z"
        />
        <path
          className="cls-2"
          d="m299.17,31.36h-2.25v-8.73c0-2.2-1.18-3.82-3.37-3.82s-3.62,1.62-3.62,3.77v8.79h-2.28v-14.37h2.2v1.56c.94-1.2,2.36-1.93,4.02-1.93,3.37,0,5.3,2.51,5.3,6.08v8.65Z"
        />
        <path
          className="cls-2"
          d="m315.59,26.9c-.96,3.07-3.32,4.8-6.51,4.8-3.96,0-7.07-3.29-7.07-7.51s3.11-7.56,6.94-7.56c3.56,0,6.99,3.07,6.96,8.18h-11.6c.29,2.98,2.49,4.74,4.77,4.74,1.96,0,3.35-.98,4.1-2.65h2.41Zm-2.2-4.21c-.56-2.34-2.44-3.9-4.44-3.9-1.9,0-3.91,1.45-4.5,3.9h8.94Z"
        />
        <path
          className="cls-2"
          d="m331.26,26.9c-.96,3.07-3.32,4.8-6.51,4.8-3.96,0-7.07-3.29-7.07-7.51s3.11-7.56,6.94-7.56c3.56,0,6.99,3.07,6.96,8.18h-11.6c.29,2.98,2.49,4.74,4.77,4.74,1.96,0,3.35-.98,4.1-2.65h2.41Zm-2.2-4.21c-.56-2.34-2.44-3.9-4.44-3.9-1.9,0-3.91,1.45-4.5,3.9h8.94Z"
        />
        <path
          className="cls-2"
          d="m341.06,19c-2.38-.14-4.42,1.17-4.42,4.05v8.31h-2.28v-14.37h2.2v1.62c1.04-1.54,2.92-2.15,4.5-1.95v2.34Z"
        />
        <path
          className="cls-2"
          d="m345.91,14.82h-2.28v-2.82h2.28v2.82Zm0,16.54h-2.28v-14.37h2.28v14.37Z"
        />
        <path
          className="cls-2"
          d="m361.37,31.36h-2.25v-8.73c0-2.2-1.18-3.82-3.37-3.82s-3.62,1.62-3.62,3.77v8.79h-2.28v-14.37h2.2v1.56c.94-1.2,2.36-1.93,4.02-1.93,3.37,0,5.3,2.51,5.3,6.08v8.65Z"
        />
        <path
          className="cls-2"
          d="m378.08,30.69c0,4.6-2.86,7.73-7.1,7.73-3.27,0-5.81-1.81-6.51-4.74h2.38c.91,2.15,3.11,2.45,4.12,2.45,3.53,0,4.82-2.85,4.82-5.44v-1.51c-.99,1.4-2.7,2.54-4.69,2.54-3.96,0-6.91-3.38-6.91-7.53s2.95-7.56,6.91-7.56c2.03,0,3.8,1.2,4.77,2.65v-2.29h2.2v13.7Zm-6.96-11.86c-2.6,0-4.63,2.4-4.63,5.38s2.03,5.33,4.63,5.33,4.69-2.4,4.69-5.33-2.14-5.38-4.69-5.38Z"
        />
        <path
          className="cls-2"
          d="m383.84,28.49v3.51c0,1.9-1.26,2.82-2.49,2.93v-1.2c.86-.14,1.34-.78,1.34-1.73v-.64h-1.53v-2.87h2.68Z"
        />
        <rect className="cls-2" x="394" y="14.82" width="2.31" height="16.96" />
        <path
          className="cls-2"
          d="m412.26,31.78h-2.28v-8.5c0-2.15-1.19-3.72-3.42-3.72s-3.67,1.57-3.67,3.66v8.56h-2.3v-13.98h2.22v1.52c.95-1.17,2.39-1.88,4.07-1.88,3.42,0,5.37,2.45,5.37,5.92v8.42Z"
        />
        <path
          className="cls-2"
          d="m422.14,32.11c-3.85,0-7-3.26-7-7.3s3.15-7.36,7-7.36c3.12,0,5.56,1.85,6.52,4.67h-2.47c-.78-1.53-2.22-2.55-4.04-2.55-2.58,0-4.69,2.36-4.69,5.24s2.12,5.18,4.69,5.18c1.85,0,3.29-1.03,4.04-2.55h2.47c-.92,2.83-3.4,4.67-6.52,4.67"
        />
        <path
          className="cls-2"
          d="m430.21,30.18c0-.33.12-.61.35-.85.23-.24.52-.35.85-.35s.61.11.84.35c.24.24.36.52.36.85s-.12.61-.35.85c-.24.22-.52.35-.85.35s-.62-.12-.85-.35-.35-.51-.35-.85"
        />
      </svg>
    )
  }
}

export default NavLogoAlt
